import { configureStore } from '@reduxjs/toolkit'
import roleReducer from './Counter/permissionData'
import createGroupReducer from './Counter/createGroup'

export const store = configureStore({
  reducer: {
    roleData:roleReducer,
    createGroup:createGroupReducer,
  },
})